import type React from "react";
import { createElement } from "react";

import data from "@emoji-mart/data";
import { init } from "emoji-mart";

import { cx, styled } from "simplydo/react/styled";

init({ data });

const SelectedContainer = styled.div<{ $size?: number }>`
  width: ${({ $size }) => ($size ? `${$size}px` : "20px")};
  height: ${({ $size }) => ($size ? `${$size}px` : "20px")};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.is-selected {
    background-color: ${({ theme }) => theme?.primaryColour || "#cacaca"};
  }

  &:not(.is-selected) {
    background-color: transparent;
  }

  em-emoji > span > span {
    display: block;
    line-height: 1;
  }

  &.is-clickable {
    cursor: pointer;

    button,
    span {
      cursor: pointer;
    }

    span:hover {
      opacity: 75%;
    }
  }

  &:not(.is-clickable) {
    cursor: inherit;

    button,
    span {
      cursor: inherit;
    }
  }
`;

type EmojiComponentProps = {
  selected?: boolean;
  emoji: { id: string };
  onClick?: (emoji: any) => void;
  size?: number;
  style?: React.CSSProperties;
};

export const Emoji = ({
  selected,
  emoji,
  onClick,
  size,
  style,
  ...rest
}: EmojiComponentProps) => {
  return (
    <SelectedContainer
      className={cx(selected && "is-selected", onClick && "is-clickable")}
      $size={size}
      style={style}
      onClick={onClick ? () => onClick(emoji) : undefined}
    >
      {createElement("em-emoji", { id: emoji.id, size })}
    </SelectedContainer>
  );
};
